export default __webpack_public_path__ + "static/media/git.d6c372fd.png";